import { currentYear } from '@/common/context/constants'

const Footer = () => {
  return (
    <footer className="footer">
      <span className="pz-sparkle" aria-hidden="true">✦</span>
      <span>{currentYear} © Prezynt</span>
    </footer>
  )
}

export default Footer
